export default __webpack_public_path__ + "static/media/skykick-300w-min.13002039.jpeg";